import { FunctionComponent } from 'react'
import OrderScroll from './OrderScroll'

type OrderListProps = {}

const OrderList: FunctionComponent<OrderListProps> = () => {
  return (
    <div>
      <OrderScroll/>
    </div>
  )
}

export default OrderList
